import React from "react";
import { Select, Divider, Typography, Skeleton } from "antd";
import { connect } from 'react-redux';
import debounce from "lodash.debounce";
import icons from "Common/Icons";
import api from 'utils/api';
import { CONSTANTS } from "utils/constant";
import utils from "utils";
class SearchComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            role: this.props.user_details?.role,
            search_suggestion: [],
            selectedValue: this.props.defaultValue || null,
            allPatientsScreen:this.props.enabled || false,
            allPatients:this.props?.allPatients || false,
            spinnerLoading:false
        }
    }

    handleOnSearch = debounce((value) => {
        var role = this.state.role;
        let name = value ? value.trim() : value;
        if (name.length > 0) {
            this.setState({spinnerLoading:true})
            api.appointment_search_suggestion(role, name, this.state.allPatients, this.state.allPatientsScreen).then(res => {
                let response = res.data?.data?.results;
                this.setState({spinnerLoading:false, search_suggestion: response})
            })
        }
    }, 800)
    handleChangeSelect(name) {
        this.setState({selectedValue: name})
        if (typeof this.props.onChange == "function") {
            return this.props.onChange(name);
        }

    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.defaultValue !== prevState.selectedValue) {
            return {
                selectedValue: nextProps.defaultValue,
            };
        } else return null;
    }

    render() { 
        return (
                <div className="search-dropdown">
{this.state.allPatientsScreen?
<>
                    <img src={this.state.role == "doctor" ? icons.search_all_patients : icons.search} style={{left:"12px"}} className="select-search-icon" />                    
                    <Select
                        value={this.state.selectedValue}
                        showSearch
                        allowClear
                        onChange={this.handleChangeSelect.bind(this)}
                        onSearch={this.handleOnSearch.bind(this)}
                        getPopupContainer={trigger => trigger.parentNode}
                        style={{ minWidth: "230px", left:"-12px" }}
                        placeholder={this.state.role == "doctor" ? <div className="search-by-patient">{CONSTANTS.SEARCH_BY_PATIENT_NEW}</div> : `${CONSTANTS.SEARCH_BY_DOCTOR}` }
                        optionFilterProp="children"
                        optionLabelProp="label"
                        filterOption={false}
                        // filterOption={(input, option) =>
                        //     option.children
                        //         .toLowerCase()
                        //         .indexOf(input.toLowerCase()) >= 0
                        // }
                        // filterSort={(optionA, optionB) =>
                        //     optionA.children
                        //         .toLowerCase()
                        //         .localeCompare(optionB.children.toLowerCase())
                        // }
                    >
                        {this.state.spinnerLoading ? <Select.Option value={null}><Skeleton paragraph={{ rows: 2, }}/></Select.Option> : this.state.search_suggestion.map((m, i) => (
                            <Select.Option value={m.patient_uid} key={i}  label={<Typography.Text ellipsis={{tooltip: m.name}}>{`${m.name} (${m.patient_uid})`}</Typography.Text>}>
                                <div className="option-section">
                                    <span className="name"><Typography.Text ellipsis={{tooltip: m.name}}>{m.name}</Typography.Text></span>
                                    <div className="doctor-specl-regno allPatients-content">{utils.ConvertToPascalCase(m.gender)}, {m.age} years</div>
                                    <span className="doctor-specl-regno" style={{ display: "inline-block", wordWrap: "break-word",whiteSpace: "normal"}}>
                                    {m.patient_uid}
                                    </span>
                                </div>
                            <Divider style={{ margin: "0px", padding: "0px" }} />                                
                            </Select.Option>
                        ))}
                    </Select>
                    </> :
                    <>
                    <img src={icons.search} className="select-search-icon" />                    
                    <Select
                        value={this.state.selectedValue}
                        showSearch
                        allowClear
                        onChange={this.handleChangeSelect.bind(this)}
                        onSearch={this.handleOnSearch.bind(this)}
                        getPopupContainer={trigger => trigger.parentNode}
                        style={{ minWidth: "230px" }}
                        placeholder={this.state.role == "doctor" ? `${CONSTANTS.SEARCH_BY_PATIENT}` : `${CONSTANTS.SEARCH_BY_DOCTOR}` }
                        optionFilterProp="children"
                        filterOption={false}
                        // filterOption={(input, option) =>
                        //     option.children
                        //         .toLowerCase()
                        //         .indexOf(input.toLowerCase()) >= 0
                        // }
                        // filterSort={(optionA, optionB) =>
                        //     optionA.children
                        //         .toLowerCase()
                        //         .localeCompare(optionB.children.toLowerCase())
                        // }
                    >
                        {this.state.search_suggestion.map((m, i) => (
                            <Select.Option value={m} key={i}>
                                {m}
                            </Select.Option>
                        ))}
                    </Select>
                    </>}

                    
                    
                </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user_details: state.loginReducer.user_details,
    };
};
export default connect(mapStateToProps)(SearchComponent)
